import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  UNSUBSCRIBE_TEXT_INPUT: `${cleanedFilename(
    __filename,
  )}-unsubscribe-text-input`,
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
};
